import { $ as ye, $n as Lt, An as Dt, Ci as Bt, Cn as Mt, Es as Et, Ki as Me, Lt as lt, Oo as Pt, Sn as Rt, Uc as qt, aa as zt, bn as Ot, ll as qe, uc as $t, xa as ze, xn as jt, yn as Ft } from "./icon-CJVFAm1E.js";
import { t as u } from "./isDefined-fMi6eQ4r.js";
import { a as V, h as Wt, m as Kt, p as Ht, r as M, t as Jt } from "./theme-B90C-74v.js";
import { n as Vt, t as ve } from "./handleClickableElementKeyDown-CJ_JsX2K.js";
import { f as Gt } from "./utilities-D50JxcQi.js";
import { n as Ut } from "./linkifyText-BINRNP9w.js";
import { a as Yt, i as Xt, o as P, s as Qt, t as Zt } from "./Input-DOoSscrP.js";
import { t as G } from "./mergeClassNames-BHKm1BNi.js";
import { n as er, t as tr } from "./ProgressBar-RWLNIkzm.js";
import { n as dt, r as ut, t as se } from "./OverflowingTextWithTooltip-Q3WsleFe.js";
import { t as rr } from "./HorizontalSeparator-JwV0dB5W.js";
import { r as nr } from "./ListItem.module-2-JdpOva.js";
import { n as ar, t as pe } from "./ListItem-Dp5FCrJm.js";
import { t as or } from "./Heading-DvxTKEaL.js";
import { a as he, n as ir, r as sr, t as cr } from "./MenuSeparator-CcTm6JVY.js";
import { t as lr } from "./Avatar-DfDIk5hO.js";
import { n as dr, t as ur } from "./TabsTabContent-1vWFmipL.js";
import { clsx as p } from "clsx";
import { Fragment as z, jsx as r, jsxs as h } from "react/jsx-runtime";
import { isArray as mr, isBoolean as _r, isFunction as vr, isNonEmptyArray as pr, isNonEmptyString as W, isNumber as hr, isPositiveInteger as fr, isString as te } from "@sniptt/guards";
import { Collapsible as Ye } from "@base-ui/react/collapsible";
import { createContext as Oe, forwardRef as $e, useCallback as Ee, useContext as le, useEffect as gr, useId as re, useLayoutEffect as fe, useMemo as br, useRef as je, useState as D } from "react";
import { Button as mt } from "@base-ui/react/button";
import { useRender as de } from "@base-ui/react/use-render";
import { Store as Cr, useStore as Ir } from "@base-ui/utils/store";
import { useDirection as yr } from "@base-ui/react/direction-provider";
import { createPortal as Nr } from "react-dom";
import { Input as wr } from "@base-ui/react/input";
import { Popover as _t } from "@base-ui/react/popover";
import { useMergedRefs as kr } from "@base-ui/utils/useMergedRefs";
var Sr = "_container_q2iju_1", Tr = "_itemContainer_q2iju_6", xr = "_overflowCountContainer_q2iju_22", Ar = "_overflowCount_q2iju_22", Z = {
  container: Sr,
  itemContainer: Tr,
  overflowCountContainer: xr,
  overflowCount: Ar
}, Lr = 4, cs = ({ avatars: e, className: t, maxVisible: n = Lr, overflowAvatar: a, overflowCount: o = 0, overflowShape: i = "square", overlap: s = "right", overlapOffset: c = "3px" }) => {
  const d = e.slice(0, n), l = !a && o > 0;
  if (!d.length && !a && !l) return null;
  const m = { "--avatar-group-overlap-offset": c };
  return /* @__PURE__ */ h("div", {
    className: p(Z.container, t),
    children: [
      d.map((_, v) => /* @__PURE__ */ r("div", {
        className: Z.itemContainer,
        "data-overlap": s,
        style: m,
        children: _
      }, v)),
      a && /* @__PURE__ */ r("div", {
        className: Z.itemContainer,
        "data-overlap": s,
        style: m,
        children: a
      }),
      l && /* @__PURE__ */ r("div", {
        className: p(Z.itemContainer, Z.overflowCountContainer),
        "data-overlap": s,
        style: m,
        children: /* @__PURE__ */ h("div", {
          className: Z.overflowCount,
          "data-shape": i,
          children: ["+", o]
        })
      })
    ]
  });
}, Dr = "_container_stu26_1", Br = "_commandContain_stu26_12", Mr = "_buttonContainer_stu26_16", Er = "_lineStartSpan_stu26_20", Pr = "_lineSpan_stu26_24", ae = {
  container: Dr,
  commandContain: Br,
  buttonContainer: Mr,
  lineStartSpan: Er,
  lineSpan: Pr
}, ls = ({ commands: e, button: t }) => /* @__PURE__ */ h("div", {
  className: ae.container,
  children: [/* @__PURE__ */ r("div", {
    className: ae.commandContain,
    children: /* @__PURE__ */ r(z, { children: e.map((n, a) => /* @__PURE__ */ h("div", { children: [/* @__PURE__ */ r("span", {
      className: ae.lineStartSpan,
      children: "> "
    }), /* @__PURE__ */ r("span", {
      className: ae.lineSpan,
      children: n
    })] }, a)) })
  }), t && /* @__PURE__ */ r("div", {
    className: ae.buttonContainer,
    children: t
  })]
}), Rr = "_list_80v6h_1", qr = "_nested_80v6h_8", Xe = {
  list: Rr,
  nested: qr
}, zr = ({ depth: e, className: t, children: n }) => /* @__PURE__ */ r("ul", {
  className: p(Xe.list, e > 0 && Xe.nested, t),
  children: n
}), vt = Oe(void 0), ne = () => {
  const e = le(vt);
  if (!u(e)) throw new Error("useJsonTreeContextOrThrow must be used within a JsonTreeContextProvider");
  return e;
}, Or = "_button_1ix33_1", $r = "_red_1ix33_17", jr = "_chevron_1ix33_22", Ne = {
  button: Or,
  red: $r,
  chevron: jr
}, Fr = ({ isOpen: e, onClick: t, variant: n }) => {
  const a = M(), { arrowButtonCollapsedLabel: o, arrowButtonExpandedLabel: i } = ne(), s = n === "blue" ? V.color.blue : n === "red" ? V.font.color.danger : V.font.color.secondary;
  return /* @__PURE__ */ h("button", {
    className: p(Ne.button, n === "red" && Ne.red),
    onClick: t,
    children: [/* @__PURE__ */ r(Vt, { children: e ? i : o }), /* @__PURE__ */ r("div", {
      className: Ne.chevron,
      "data-open": e || void 0,
      children: /* @__PURE__ */ r(jt, {
        size: a.icon.size.md,
        color: s
      })
    })]
  });
}, Wr = ({ label: e, value: t, depth: n, keyPath: a, highlighting: o }) => {
  const { emptyArrayLabel: i } = ne();
  return /* @__PURE__ */ r(Fe, {
    elements: [...t.entries()].map(([s, c]) => ({
      id: s,
      label: String(s),
      value: c
    })),
    renderElementsCount: (s) => `[${s}]`,
    label: e,
    Icon: lt,
    depth: n,
    emptyElementsText: i,
    keyPath: a,
    highlighting: o
  });
}, Kr = ({ label: e, value: t, depth: n, keyPath: a, highlighting: o }) => {
  const { emptyObjectLabel: i } = ne();
  return /* @__PURE__ */ r(Fe, {
    elements: Object.entries(t).map(([s, c]) => ({
      id: s,
      label: s,
      value: c
    })),
    renderElementsCount: (s) => `{${s}}`,
    label: e,
    Icon: Lt,
    depth: n,
    emptyElementsText: i,
    keyPath: a,
    highlighting: o
  });
}, Hr = "_labelContainer_1pq94_1", Jr = "_blue_1pq94_23", Vr = "_red_1pq94_29", we = {
  labelContainer: Hr,
  blue: Jr,
  red: Vr
}, pt = ({ label: e, Icon: t, highlighting: n }) => {
  const a = M();
  return /* @__PURE__ */ h("span", {
    className: p(we.labelContainer, n === "blue" && we.blue, n === "red" && we.red),
    children: [/* @__PURE__ */ r(t, {
      size: a.icon.size.md,
      color: n === "blue" ? a.color.blue : n === "red" ? a.font.color.danger : a.font.color.tertiary
    }), /* @__PURE__ */ r("span", { children: e })]
  });
}, Gr = "_text_3y2ep_1", Ur = "_blue_3y2ep_10", Yr = "_red_3y2ep_14", ke = {
  text: Gr,
  blue: Ur,
  red: Yr
}, Xr = ({ valueAsString: e, highlighting: t }) => {
  const { onNodeValueClick: n } = ne(), a = u(n), o = () => {
    n?.(e);
  }, i = p(ke.text, t === "blue" && ke.blue, t === "red" && ke.red);
  return a ? /* @__PURE__ */ r("span", {
    className: i,
    role: "button",
    tabIndex: 0,
    onClick: o,
    onKeyDown: ve,
    children: e
  }) : /* @__PURE__ */ r("span", {
    className: i,
    children: e
  });
}, Qr = "_listItem_1i7if_1", Zr = { listItem: Qr }, ie = (e) => /* @__PURE__ */ h("li", {
  className: Zr.listItem,
  children: [e.label && /* @__PURE__ */ r(pt, {
    label: e.label,
    Icon: e.Icon,
    highlighting: e.highlighting
  }), /* @__PURE__ */ r(Xr, {
    valueAsString: e.valueAsString,
    highlighting: e.highlighting
  })]
}), en = (e) => mr(e), ht = ({ label: e, value: t, depth: n, keyPath: a }) => {
  const { getNodeHighlighting: o, emptyStringLabel: i } = ne(), s = o?.(a);
  return u(t) ? te(t) ? /* @__PURE__ */ r(ie, {
    label: e,
    valueAsString: W(t) ? t : i,
    Icon: qt,
    highlighting: s
  }) : hr(t) ? /* @__PURE__ */ r(ie, {
    label: e,
    valueAsString: String(t),
    Icon: Pt,
    highlighting: s
  }) : _r(t) ? /* @__PURE__ */ r(ie, {
    label: e,
    valueAsString: String(t),
    Icon: Ot,
    highlighting: s
  }) : en(t) ? /* @__PURE__ */ r(Wr, {
    label: e,
    value: t,
    depth: n,
    keyPath: a,
    highlighting: s
  }) : /* @__PURE__ */ r(Kr, {
    label: e,
    value: t,
    depth: n,
    keyPath: a,
    highlighting: s
  }) : /* @__PURE__ */ r(ie, {
    label: e,
    valueAsString: "null",
    Icon: Dt,
    highlighting: s
  });
}, tn = "_container_1c6yj_1", rn = "_labelContainer_1c6yj_6", nn = "_elementsCount_1c6yj_12", an = "_elementsCountRed_1c6yj_16", on = "_panel_1c6yj_20", sn = "_list_1c6yj_30", cn = "_nested_1c6yj_37", U = {
  container: tn,
  labelContainer: rn,
  elementsCount: nn,
  elementsCountRed: an,
  panel: on,
  list: sn,
  nested: cn
}, Fe = ({ label: e, Icon: t, elements: n, renderElementsCount: a, emptyElementsText: o, depth: i, keyPath: s, highlighting: c }) => {
  const { shouldExpandNodeInitially: d } = ne(), l = !u(e), [m, _] = D(d({
    keyPath: s,
    depth: i
  })), v = /* @__PURE__ */ r("ul", {
    className: p(U.list, i > 0 && U.nested),
    children: n.length === 0 ? /* @__PURE__ */ r(ie, {
      valueAsString: o,
      highlighting: void 0
    }) : n.map(({ id: g, label: S, value: y }) => {
      const b = W(s) ? `${s}.${g}` : String(g);
      return /* @__PURE__ */ r(ht, {
        label: S,
        value: y,
        depth: i + 1,
        keyPath: b
      }, g);
    })
  }), f = () => {
    _(!m);
  };
  return l ? /* @__PURE__ */ r("li", {
    className: U.container,
    children: v
  }) : /* @__PURE__ */ h(Ye.Root, {
    className: U.container,
    open: m,
    render: /* @__PURE__ */ r("li", {}),
    children: [/* @__PURE__ */ h("div", {
      className: U.labelContainer,
      children: [
        /* @__PURE__ */ r(Fr, {
          isOpen: m,
          onClick: f,
          variant: c === "partial-blue" ? "blue" : c === "red" ? c : void 0
        }),
        /* @__PURE__ */ r(pt, {
          label: e,
          Icon: t,
          highlighting: c === "red" ? c : void 0
        }),
        a && /* @__PURE__ */ r("span", {
          className: p(U.elementsCount, c === "red" && U.elementsCountRed),
          children: a(n.length)
        })
      ]
    }), /* @__PURE__ */ r(Ye.Panel, {
      className: U.panel,
      children: v
    })]
  });
}, ln = ({ value: e, children: t }) => /* @__PURE__ */ r(vt.Provider, {
  value: e,
  children: t
}), dn = ({ depth: e }) => e <= 1, ds = ({ value: e, entries: t, shouldExpandNodeInitially: n = dn, ...a }) => /* @__PURE__ */ r(ln, {
  value: {
    ...a,
    shouldExpandNodeInitially: n
  },
  children: /* @__PURE__ */ r(zr, {
    depth: 0,
    children: u(t) ? /* @__PURE__ */ r(Fe, {
      elements: t,
      Icon: lt,
      depth: 0,
      keyPath: "",
      emptyElementsText: a.emptyObjectLabel
    }) : /* @__PURE__ */ r(ht, {
      value: e ?? null,
      depth: 0,
      keyPath: ""
    })
  })
}), un = "_notificationCounter_1lalu_1", mn = "_primary_1lalu_13", _n = "_secondary_1lalu_18", Qe = {
  notificationCounter: un,
  primary: mn,
  secondary: _n
}, us = ({ count: e, variant: t = "primary", className: n }) => /* @__PURE__ */ r("div", {
  className: p(Qe.notificationCounter, Qe[t], n),
  children: e
}), vn = "_root_j2xk4_1", pn = { root: vn }, hn = ({ $backgroundColor: e, $borderColor: t, $dimension: n, className: a, style: o, ...i }) => /* @__PURE__ */ r("div", {
  ...i,
  className: p(pn.root, a),
  style: {
    "--tinted-icon-tile-background-color": e,
    "--tinted-icon-tile-border": t ? `1px solid ${t}` : void 0,
    "--tinted-icon-tile-dimension": n,
    ...o
  }
}), Se = {
  background: 4,
  border: 6,
  icon: 10
}, Te = (e, t) => {
  const n = V.color[`${e}${t}`];
  return typeof n == "string" ? n : V.tag.text[e];
}, fn = (e) => {
  const t = Gt(e);
  return {
    backgroundColor: Te(t, Se.background),
    iconColor: Te(t, Se.icon),
    borderColor: Te(t, Se.border)
  };
}, ft = ({ Icon: e, color: t = Wt, size: n, stroke: a }) => {
  const o = M(), i = fn(t), s = n ?? o.icon.size.md, c = a ?? o.icon.stroke.md, d = u(n) ? `${n}px` : void 0;
  return /* @__PURE__ */ r(hn, {
    $backgroundColor: i.backgroundColor,
    $dimension: d,
    children: /* @__PURE__ */ r(e, {
      size: s,
      stroke: c,
      color: i.iconColor
    })
  });
}, gn = "_container_1yqen_1", bn = "_containerFullWidth_1yqen_14", Cn = "_containerInfo_1yqen_18", In = "_containerWarning_1yqen_23", yn = "_containerSuccess_1yqen_28", Nn = "_containerError_1yqen_33", wn = "_containerNeutral_1yqen_38", kn = "_header_1yqen_43", Sn = "_iconContainer_1yqen_52", Tn = "_iconContainerInfo_1yqen_61", xn = "_iconContainerWarning_1yqen_65", An = "_iconContainerSuccess_1yqen_69", Ln = "_iconContainerError_1yqen_73", Dn = "_iconContainerNeutral_1yqen_77", Bn = "_title_1yqen_81", Mn = "_descriptionWrapper_1yqen_93", En = "_descriptionWrapperWithAction_1yqen_101", Pn = "_description_1yqen_93", Rn = "_footer_1yqen_114", qn = "_closeButton_1yqen_121", x = {
  container: gn,
  containerFullWidth: bn,
  containerInfo: Cn,
  containerWarning: In,
  containerSuccess: yn,
  containerError: Nn,
  containerNeutral: wn,
  header: kn,
  iconContainer: Sn,
  iconContainerInfo: Tn,
  iconContainerWarning: xn,
  iconContainerSuccess: An,
  iconContainerError: Ln,
  iconContainerNeutral: Dn,
  title: Bn,
  descriptionWrapper: Mn,
  descriptionWrapperWithAction: En,
  description: Pn,
  footer: Rn,
  closeButton: qn
}, zn = {
  info: x.containerInfo,
  warning: x.containerWarning,
  error: x.containerError,
  neutral: x.containerNeutral,
  success: x.containerSuccess
}, On = {
  info: x.iconContainerInfo,
  warning: x.iconContainerWarning,
  error: x.iconContainerError,
  neutral: x.iconContainerNeutral,
  success: x.iconContainerSuccess
}, ms = ({ variant: e, title: t, description: n, fullWidth: a = !1, Icon: o = zt, action: i, isClosable: s = !1, onClose: c }) => {
  const [d, l] = D(!0), m = () => {
    s && (l(!1), c?.());
  };
  return d ? /* @__PURE__ */ h("div", {
    className: p(x.container, zn[e], a && x.containerFullWidth),
    children: [
      /* @__PURE__ */ h("div", {
        className: x.header,
        children: [
          /* @__PURE__ */ r("div", {
            className: p(x.iconContainer, On[e]),
            children: /* @__PURE__ */ r(o, { size: 16 })
          }),
          /* @__PURE__ */ r("div", {
            className: x.title,
            children: t
          }),
          s && /* @__PURE__ */ r(P, {
            startIcon: /* @__PURE__ */ r(qe, {}),
            className: x.closeButton,
            variant: "ghost",
            size: "sm",
            "aria-label": "Close",
            onClick: m
          })
        ]
      }),
      W(n) && /* @__PURE__ */ r("div", {
        className: p(x.descriptionWrapper, u(i) && x.descriptionWrapperWithAction),
        children: /* @__PURE__ */ r("div", {
          className: x.description,
          children: n
        })
      }),
      u(i) && /* @__PURE__ */ r("div", {
        className: x.footer,
        children: /* @__PURE__ */ r(P, {
          type: "button",
          onClick: i.onClick,
          size: "sm",
          variant: "ghost",
          style: { fontWeight: "var(--t-font-weight-regular)" },
          children: i.label
        })
      })
    ]
  }) : null;
}, $n = "_info_phgej_1", jn = "_accentBlue_phgej_14", Fn = "_accentDanger_phgej_19", Wn = "_textContainer_phgej_24", Kn = "_linkContainer_phgej_33", ce = {
  info: $n,
  accentBlue: jn,
  accentDanger: Fn,
  textContainer: Wn,
  linkContainer: Kn
}, Hn = {
  blue: ce.accentBlue,
  danger: ce.accentDanger
}, _s = ({ accent: e = "blue", text: t, buttonTitle: n, onClick: a, href: o, render: i }) => {
  const s = M();
  return /* @__PURE__ */ h("div", {
    className: p(ce.info, Hn[e]),
    children: [
      /* @__PURE__ */ h("div", {
        className: ce.textContainer,
        children: [/* @__PURE__ */ r(ze, { size: s.icon.size.md }), t]
      }),
      n && o && /* @__PURE__ */ r("span", {
        className: ce.linkContainer,
        children: /* @__PURE__ */ r(P, {
          href: o,
          render: i,
          size: "sm",
          variant: "outline",
          color: e === "blue" ? "accent" : "danger",
          children: n
        })
      }),
      n && a && !o && /* @__PURE__ */ r(P, {
        onClick: a,
        size: "sm",
        variant: "outline",
        color: e === "blue" ? "accent" : "danger",
        children: n
      })
    ]
  });
}, Jn = "_banner_j76tb_1", Vn = "_embedded_j76tb_6", Gn = "_bannerContent_j76tb_10", Un = "_bannerText_j76tb_21", me = {
  banner: Jn,
  embedded: Vn,
  bannerContent: Gn,
  bannerText: Un
}, vs = ({ color: e, message: t, embedded: n = !1, button: a, LeftIcon: o = ze, className: i }) => {
  const s = M();
  return /* @__PURE__ */ h(er, {
    className: p(me.banner, n && me.embedded, i),
    color: e,
    variant: "secondary",
    children: [/* @__PURE__ */ h("div", {
      className: me.bannerContent,
      children: [/* @__PURE__ */ r(o, { size: s.icon.size.md }), /* @__PURE__ */ r("div", {
        className: me.bannerText,
        children: /* @__PURE__ */ r(se, {
          isFocusable: !0,
          text: /* @__PURE__ */ r(z, { children: t }),
          tooltipContent: t
        })
      })]
    }), a && !a.hidden && /* @__PURE__ */ r(P, {
      size: "sm",
      onClick: a?.onClick,
      disabled: a.disabled,
      startIcon: u(a.Icon) ? /* @__PURE__ */ r(a.Icon, {}) : void 0,
      variant: "outline",
      color: e === "danger" ? "danger" : "accent",
      children: a?.title
    })]
  });
}, ps = 3, gt = Oe(void 0), ge = (e) => e.status === "visible", bt = ({ store: e, toastsToClose: t, nextToasts: n = e.state.toasts }) => {
  const a = n.map((i) => t.includes(i) ? {
    ...i,
    status: "closing"
  } : i), o = e.state.mountedToasterCount > 0;
  e.set("toasts", o ? a : a.filter(ge));
  for (const i of t) i.notification.onClose?.();
}, ue = () => {
  const e = le(gt);
  if (!u(e)) throw new Error("Toast components must be used within a ToastProvider.");
  return e;
}, Ct = () => {
  const e = ue();
  return { closeToast: (n) => {
    const a = e.state.toasts.filter((o) => ge(o) && (!u(n) || o.notification.id === n));
    pr(a) && bt({
      store: e,
      toastsToClose: a
    });
  } };
}, Ze = 0, Yn = () => {
  const e = ue();
  return { enqueueToast: br(() => {
    function t(n) {
      if (!u(n)) return;
      const { dedupeKey: a, ...o } = n, { toasts: i, limit: s } = e.state, c = i.filter(ge), d = u(a) ? c.find((_) => _.dedupeKey === a) : void 0;
      if (u(d)) return d.notification.id;
      Ze += 1;
      const l = `toast-${Ze}`, m = Math.max(0, c.length - s + 1);
      return bt({
        store: e,
        toastsToClose: c.slice(0, m),
        nextToasts: [...i, {
          notification: {
            ...o,
            id: l
          },
          dedupeKey: a,
          status: "visible"
        }]
      }), l;
    }
    return t;
  }, [e]) };
}, hs = () => {
  const { closeToast: e } = Ct(), { enqueueToast: t } = Yn();
  return {
    enqueueToast: t,
    closeToast: e
  };
}, Xn = () => {
  const e = ue();
  return Ir(e, (t) => t.toasts);
}, Qn = (e = 3) => {
  if (!fr(e)) throw new Error("Toast limit must be a positive integer.");
  return new Cr({
    toasts: [],
    limit: e,
    mountedToasterCount: 0
  });
}, Zn = "_root_1ssdh_1", ea = "_progress_1ssdh_19", ta = "_header_1ssdh_30", ra = "_message_1ssdh_39", na = "_icon_1ssdh_44", aa = "_actions_1ssdh_49", oa = "_description_1ssdh_55", ia = "_footer_1ssdh_64", sa = "_footerAction_1ssdh_68", ca = "_closeButton_1ssdh_75", j = {
  root: Zn,
  progress: ea,
  header: ta,
  message: ra,
  icon: na,
  actions: aa,
  description: oa,
  footer: ia,
  footerAction: sa,
  closeButton: ca
}, la = {
  default: ye,
  error: ye,
  success: $t,
  info: ze,
  warning: ye
}, da = ({ children: e, description: t, icon: n, iconLabel: a, action: o, progress: i, duration: s = 6e3, onCancel: c, onClose: d, cancelLabel: l = "Cancel", closeLabel: m = "Close", variant: _ = "default", role: v = "status", className: f, onMouseEnter: g, onMouseLeave: S, render: y, ref: b, ...T }) => {
  const N = M(), [k, A] = D(!1), L = la[_];
  return de({
    render: y,
    ref: b,
    props: {
      role: v,
      "aria-live": v === "alert" ? "assertive" : "polite",
      ...T,
      className: p(j.root, f),
      onMouseEnter: (C) => {
        A(!0), g?.(C);
      },
      onMouseLeave: (C) => {
        A(!1), S?.(C);
      },
      children: /* @__PURE__ */ h(z, { children: [
        /* @__PURE__ */ r("div", {
          className: j.progress,
          "aria-hidden": !0,
          children: /* @__PURE__ */ r(tr, {
            barColor: N.snackBar[_].backgroundColor,
            value: i ?? 100,
            countdownDurationInMs: u(i) ? void 0 : s,
            isCountdownPaused: k,
            onCountdownComplete: d
          })
        }),
        /* @__PURE__ */ h("div", {
          className: j.header,
          children: [
            /* @__PURE__ */ r("div", {
              className: j.icon,
              children: n ?? /* @__PURE__ */ r(L, {
                "aria-label": a,
                "aria-hidden": !u(a),
                color: N.snackBar[_].color,
                size: N.icon.size.md
              })
            }),
            /* @__PURE__ */ r("div", {
              className: j.message,
              children: e
            }),
            /* @__PURE__ */ h("div", {
              className: j.actions,
              children: [u(c) && /* @__PURE__ */ r(P, {
                onClick: c,
                size: "sm",
                variant: "ghost",
                style: { fontWeight: "var(--t-font-weight-regular)" },
                children: l
              }), u(d) && /* @__PURE__ */ r(P, {
                title: m,
                "aria-label": m,
                startIcon: /* @__PURE__ */ r(qe, {}),
                className: j.closeButton,
                variant: "ghost",
                size: "sm",
                onClick: d
              })]
            })
          ]
        }),
        u(t) && /* @__PURE__ */ r("div", {
          className: j.description,
          children: t
        }),
        u(o) && /* @__PURE__ */ h("div", {
          className: j.footer,
          children: [/* @__PURE__ */ r(rr, { noMargin: !0 }), /* @__PURE__ */ r("div", {
            className: j.footerAction,
            children: o
          })]
        })
      ] })
    }
  });
}, fs = ({ children: e, limit: t = 3 }) => {
  const [n] = D(() => Qn(t));
  return /* @__PURE__ */ r(gt.Provider, {
    value: n,
    children: e
  });
}, et = ({ store: e, toast: t }) => {
  const { toasts: n } = e.state;
  t.status === "closing" && n.includes(t) && e.set("toasts", n.filter((a) => a !== t));
}, ua = "_root_1q2cc_1", ma = "_item_1q2cc_20", _a = "_itemContent_1q2cc_47", Pe = {
  root: ua,
  item: ma,
  itemContent: _a
}, va = ({ elementRef: e, toastEntry: t }) => {
  const n = ue();
  return fe(() => {
    if (t.status === "visible") return;
    const a = e.current?.getAnimations?.() ?? [];
    if (a.length === 0) {
      et({
        store: n,
        toast: t
      });
      return;
    }
    let o = !1;
    return Promise.allSettled(a.map((i) => i.finished)).then(() => {
      o || et({
        store: n,
        toast: t
      });
    }), () => {
      o = !0;
    };
  }, [
    e,
    t,
    n
  ]), /* @__PURE__ */ r(z, {});
}, pa = ({ toastEntry: e, getToastProps: t, onClose: n }) => {
  const { notification: a, status: o } = e, { id: i, ...s } = a, c = je(null);
  return /* @__PURE__ */ h(z, { children: [/* @__PURE__ */ r("div", {
    ref: c,
    className: Pe.item,
    "data-exiting": o === "closing" || void 0,
    inert: o === "closing",
    children: /* @__PURE__ */ r("div", {
      className: Pe.itemContent,
      children: /* @__PURE__ */ r(da, {
        ...s,
        ...t?.(a),
        id: i,
        onClose: () => n(i)
      })
    })
  }), /* @__PURE__ */ r(va, {
    elementRef: c,
    toastEntry: e
  })] });
}, ha = ({ getToastProps: e }) => {
  const t = Xn(), { closeToast: n } = Ct();
  return t.map((a) => /* @__PURE__ */ r(pa, {
    toastEntry: a,
    getToastProps: e,
    onClose: n
  }, a.notification.id));
}, fa = () => {
  const e = ue();
  return fe(() => (e.set("mountedToasterCount", e.state.mountedToasterCount + 1), () => {
    e.set("mountedToasterCount", e.state.mountedToasterCount - 1), !(e.state.mountedToasterCount > 0) && e.set("toasts", e.state.toasts.filter(ge));
  }), [e]), null;
}, gs = ({ container: e, getToastProps: t, className: n, render: a, ref: o, ...i }) => {
  const s = Jt(), c = yr(), d = e === void 0 ? s ?? (typeof document > "u" ? null : document.body) : e, l = de({
    render: a,
    ref: o,
    props: {
      role: "region",
      dir: c,
      "aria-label": "Notifications",
      ...i,
      className: p(Pe.root, n),
      children: /* @__PURE__ */ h(z, { children: [/* @__PURE__ */ r(fa, {}), /* @__PURE__ */ r(ha, { getToastProps: t })] })
    }
  });
  return u(d) ? Nr(l, d) : null;
}, ga = "_container_1gape_1", ba = "_cardInner_1gape_23", tt = {
  container: ga,
  cardInner: ba
}, bs = ({ children: e, className: t, ...n }) => /* @__PURE__ */ r(Yt, {
  render: /* @__PURE__ */ r("div", {}),
  ...n,
  className: G(tt.container, t),
  children: /* @__PURE__ */ r("div", {
    className: tt.cardInner,
    children: e
  })
}), Ca = "_root_16neu_1", Ia = { root: Ca }, rt = ({ className: e }) => {
  const t = M();
  return /* @__PURE__ */ r("div", {
    className: p(Ia.root, e),
    children: /* @__PURE__ */ r(Ft, {
      color: t.grayScale.gray1,
      size: 14
    })
  });
}, ya = "_container_qsmue_1", Na = "_colorSchemeBackground_qsmue_6", wa = "_colorSchemeContent_qsmue_22", ka = "_mixedColorSchemeSegment_qsmue_39", Sa = "_checkmarkContainer_qsmue_54", Y = {
  container: ya,
  colorSchemeBackground: Na,
  colorSchemeContent: wa,
  mixedColorSchemeSegment: ka,
  checkmarkContainer: Sa
}, xe = ({ variant: e, style: t, className: n, onClick: a, onMouseEnter: o, onMouseLeave: i }) => {
  const s = e === "Dark" ? Kt : Ht, c = p(Y.colorSchemeBackground, n), d = {
    "--color-scheme-card-background": s.gray4,
    "--color-scheme-card-border-color": s.gray5,
    "--color-scheme-card-content-background": s.gray1,
    "--color-scheme-card-content-color": s.gray12,
    ...t
  }, l = /* @__PURE__ */ r("div", {
    className: Y.colorSchemeContent,
    children: "Aa"
  });
  return u(a) ? /* @__PURE__ */ r("div", {
    className: c,
    style: d,
    role: "button",
    tabIndex: 0,
    "aria-label": e,
    onClick: a,
    onKeyDown: ve,
    onMouseEnter: o,
    onMouseLeave: i,
    children: l
  }) : /* @__PURE__ */ r("div", {
    className: c,
    style: d,
    onMouseEnter: o,
    onMouseLeave: i,
    children: l
  });
}, Ae = ({ variant: e, selected: t, onClick: n, className: a }) => {
  const o = /* @__PURE__ */ h(z, { children: [/* @__PURE__ */ r(xe, {
    style: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },
    variant: "Light"
  }), /* @__PURE__ */ r(xe, {
    style: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    },
    variant: "Dark"
  })] });
  return e === "System" ? /* @__PURE__ */ h("div", {
    className: p(Y.container, a),
    children: [u(n) ? /* @__PURE__ */ r("div", {
      className: Y.mixedColorSchemeSegment,
      role: "button",
      tabIndex: 0,
      "aria-label": e,
      onClick: n,
      onKeyDown: ve,
      children: o
    }) : /* @__PURE__ */ r("div", {
      className: Y.mixedColorSchemeSegment,
      children: o
    }), /* @__PURE__ */ r("div", {
      className: Y.checkmarkContainer,
      "data-selected": t || void 0,
      children: /* @__PURE__ */ r(rt, {})
    })]
  }) : /* @__PURE__ */ h("div", {
    className: p(Y.container, a),
    children: [/* @__PURE__ */ r(xe, {
      variant: e,
      onClick: n
    }), /* @__PURE__ */ r("div", {
      className: Y.checkmarkContainer,
      "data-selected": t || void 0,
      children: /* @__PURE__ */ r(rt, {})
    })]
  });
}, Ta = "_container_pqcwk_1", xa = "_cardContainer_pqcwk_13", Aa = "_card_pqcwk_13", La = "_label_pqcwk_29", F = {
  container: Ta,
  cardContainer: xa,
  card: Aa,
  label: La
}, Cs = ({ value: e, onChange: t, className: n, lightLabel: a, darkLabel: o, systemLabel: i }) => /* @__PURE__ */ h("div", {
  className: p(F.container, n),
  children: [
    /* @__PURE__ */ h("div", {
      className: F.cardContainer,
      children: [/* @__PURE__ */ r(Ae, {
        className: F.card,
        onClick: () => t("Light"),
        variant: "Light",
        selected: e === "Light"
      }), /* @__PURE__ */ r("span", {
        className: F.label,
        children: a
      })]
    }),
    /* @__PURE__ */ h("div", {
      className: F.cardContainer,
      children: [/* @__PURE__ */ r(Ae, {
        className: F.card,
        onClick: () => t("Dark"),
        variant: "Dark",
        selected: e === "Dark"
      }), /* @__PURE__ */ r("span", {
        className: F.label,
        children: o
      })]
    }),
    /* @__PURE__ */ h("div", {
      className: F.cardContainer,
      children: [/* @__PURE__ */ r(Ae, {
        className: F.card,
        onClick: () => t("System"),
        variant: "System",
        selected: e === "System"
      }), /* @__PURE__ */ r("span", {
        className: F.label,
        children: i
      })]
    })
  ]
}), Da = "_button_bef48_1", Ba = "_tooltipAnchor_bef48_29", Ma = "_icon_bef48_33", Le = {
  button: Da,
  tooltipAnchor: Ba,
  icon: Ma
}, Ea = ({ children: e, size: t = "md", shape: n = "square", className: a, tooltip: o, tooltipPlace: i = "bottom", tooltipDelay: s = 1e3, tooltipOffset: c = 5, disabled: d, loading: l, ...m }) => {
  const _ = le(Qt)?.size ?? t, v = W(o), f = d || l, g = /* @__PURE__ */ r(P, {
    ...m,
    size: t === "xs" ? "sm" : t,
    "data-icon-size": _,
    "data-shape": n,
    disabled: d,
    loading: l,
    startIcon: /* @__PURE__ */ r("span", {
      className: Le.icon,
      children: e
    }),
    className: G(Le.button, a)
  });
  return v ? /* @__PURE__ */ r(ut, {
    content: o,
    delay: s,
    side: i,
    sideOffset: c,
    children: f ? /* @__PURE__ */ r("span", {
      className: Le.tooltipAnchor,
      children: g
    }) : g
  }) : g;
}, Pa = "_button_2b26u_1", Ra = { button: Pa }, Is = ({ className: e, emphasis: t = "standard", size: n = "sm", variant: a = "ghost", ...o }) => /* @__PURE__ */ r(P, {
  ...o,
  size: n,
  variant: a,
  "data-emphasis": t,
  className: G(Ra.button, e)
}), qa = "_button_1mfgv_1", za = { button: qa }, Oa = ({ className: e, emphasis: t = "standard", size: n = "sm", variant: a = "ghost", ...o }) => /* @__PURE__ */ r(Ea, {
  ...o,
  size: n,
  variant: a,
  "data-emphasis": t,
  className: G(za.button, e)
}), $a = "_button_1jcxm_1", ja = { button: $a }, ys = ({ className: e, elevated: t = !0, variant: n = "solid", ...a }) => /* @__PURE__ */ r(P, {
  ...a,
  elevated: t,
  variant: n,
  className: G(ja.button, e)
}), Fa = "_wrapper_chjqn_1", Wa = "_filterButton_chjqn_8", Ka = "_filterIcon_chjqn_17", Ha = "_inputContainer_chjqn_21", Ja = "_iconContainer_chjqn_38", Va = "_input_chjqn_21", ee = {
  wrapper: Fa,
  filterButton: Wa,
  filterIcon: Ka,
  inputContainer: Ha,
  iconContainer: Ja,
  input: Va
}, Ns = ({ value: e, onChange: t, placeholder: n, filterDropdown: a, autoFocus: o, disabled: i, className: s, id: c, filterButtonAriaLabel: d = "Filter", "aria-label": l, "aria-labelledby": m }) => {
  const _ = M(), [v, f] = D(!1), g = re(), S = c ?? g, y = /* @__PURE__ */ r(P, {
    variant: "outline",
    "aria-label": d,
    startIcon: /* @__PURE__ */ r("span", {
      className: ee.filterIcon,
      children: /* @__PURE__ */ r(Bt, { size: _.icon.size.md })
    }),
    className: ee.filterButton
  });
  return /* @__PURE__ */ h("div", {
    className: p(ee.wrapper, s),
    children: [/* @__PURE__ */ h("div", {
      className: ee.inputContainer,
      children: [/* @__PURE__ */ r("div", {
        className: ee.iconContainer,
        "data-focused": v || void 0,
        "aria-hidden": !0,
        children: /* @__PURE__ */ r(Et, { size: _.icon.size.md })
      }), /* @__PURE__ */ r(wr, {
        id: S,
        className: ee.input,
        value: e,
        onValueChange: (b) => t(b),
        onFocus: () => f(!0),
        onBlur: () => f(!1),
        placeholder: n,
        autoFocus: o,
        disabled: i,
        "aria-label": m ? void 0 : l ?? n,
        "aria-labelledby": m
      })]
    }), a && a(y)]
  });
}, ws = ({ children: e, startIcon: t, description: n, focused: a = !1, checked: o, defaultChecked: i, onCheckedChange: s, disabled: c = !1, readOnly: d = !1, size: l = "sm", name: m, value: _, required: v, className: f, style: g, ref: S, ...y }) => {
  const b = re(), T = `${b}-label`, N = `${b}-description`, k = nr(n);
  return /* @__PURE__ */ r(pe, {
    className: f,
    style: g,
    startIcon: t,
    focused: a,
    disabled: c,
    description: k && /* @__PURE__ */ r("span", {
      id: N,
      children: n
    }),
    render: (A) => /* @__PURE__ */ r("label", {
      ...y,
      ...A,
      htmlFor: b,
      ref: S
    }),
    endIcon: /* @__PURE__ */ r(Xt, {
      id: b,
      "aria-labelledby": T,
      "aria-describedby": k ? N : void 0,
      checked: o,
      defaultChecked: i,
      onCheckedChange: s,
      disabled: c,
      readOnly: d,
      size: l,
      name: m,
      value: _,
      required: v
    }),
    children: /* @__PURE__ */ r("span", {
      id: T,
      children: e
    })
  });
}, Ga = "_container_gwbng_1", Ua = "_layer_gwbng_8", Ya = "_visible_gwbng_22", Xa = "_hidden_gwbng_27", Q = {
  container: Ga,
  layer: Ua,
  visible: Ya,
  hidden: Xa
}, ks = ({ isActive: e, ActiveIcon: t, InactiveIcon: n, size: a }) => {
  const o = M(), i = a ?? o.icon.size.sm;
  return /* @__PURE__ */ h("div", {
    className: Q.container,
    style: { "--animated-icon-crossfade-size": `${i}px` },
    children: [/* @__PURE__ */ r("div", {
      className: p(Q.layer, e ? Q.hidden : Q.visible),
      children: /* @__PURE__ */ r(n, { size: i })
    }), /* @__PURE__ */ r("div", {
      className: p(Q.layer, e ? Q.visible : Q.hidden),
      children: /* @__PURE__ */ r(t, { size: i })
    })]
  });
}, Qa = "_header_1r38k_1", Za = "_titleRow_1r38k_8", eo = "_title_1r38k_8", to = "_adornment_1r38k_21", ro = "_description_1r38k_27", oe = {
  header: Qa,
  titleRow: Za,
  title: eo,
  adornment: to,
  description: ro
}, no = ({ title: e, description: t, adornment: n, level: a = 2, size: o = "md", color: i = "primary", descriptionLineClamp: s = 5, render: c, ref: d, className: l, ...m }) => {
  const _ = re(), v = te(t) ? W(t) : u(t) && t !== !1;
  return de({
    render: c,
    ref: d,
    props: {
      ...m,
      className: p(oe.header, l),
      children: /* @__PURE__ */ h(z, { children: [/* @__PURE__ */ h("div", {
        className: oe.titleRow,
        children: [/* @__PURE__ */ r(or, {
          level: a,
          size: o,
          color: i,
          className: oe.title,
          "aria-describedby": v ? _ : void 0,
          children: e
        }), u(n) && /* @__PURE__ */ r("div", {
          className: oe.adornment,
          children: n
        })]
      }), v && /* @__PURE__ */ r("div", {
        id: _,
        className: oe.description,
        children: te(t) ? /* @__PURE__ */ r(se, {
          text: t,
          displayedMaxRows: s,
          isTooltipMultiline: !0,
          isFocusable: !0
        }) : t
      })] })
    }
  });
}, ao = "_root_ztxxm_1", oo = "_fullWidth_ztxxm_20", nt = {
  root: ao,
  fullWidth: oo
}, io = ({ align: e = "left", color: t = "primary", fullWidth: n = !0, className: a, render: o, ref: i, ...s }) => de({
  render: o,
  ref: i,
  props: {
    ...s,
    "data-align": e,
    "data-color": t,
    className: p(nt.root, n && nt.fullWidth, a)
  }
}), Ss = {
  Root: io,
  Header: no
}, We = (e) => e.getAttribute("aria-label") ?? e.textContent ?? "", be = (e) => Array.from(e.querySelectorAll("[data-dropdown-item]")).filter((t) => t.getAttribute("aria-disabled") !== "true" && !t.hasAttribute("disabled") && t.closest("[data-dropdown-content]") === e), _e = Oe(void 0), O = () => {
  const e = le(_e);
  if (!u(e)) throw new Error("Dropdown components must be inside Dropdown.Root");
  return e;
}, Ke = ({ id: e, isSubmenuTrigger: t = !1 }) => {
  const n = O(), a = t ? n.parentType : n.type, o = t ? n.parentActiveItemId : n.activeItemId, i = t ? n.setParentActiveItemId : n.setActiveItemId;
  return {
    tabIndex: a === "menu" && o !== e ? -1 : 0,
    activate: () => i?.(e)
  };
}, It = ({ color: e, startIcon: t, endIcon: n, description: a, descriptionPlacement: o, hotkeys: i, hasSubmenu: s, children: c, render: d, disabled: l = !1, nativeButton: m = !u(d), closeOnClick: _ = !0, onClick: v, onFocus: f, page: g, id: S, ...y }) => {
  const { type: b, closeTree: T, goToPage: N } = O(), k = re(), A = S ?? k, L = Ke({ id: A });
  return /* @__PURE__ */ r(mt, {
    ...y,
    id: A,
    disabled: l,
    nativeButton: m,
    role: y.role ?? (b === "menu" ? "menuitem" : void 0),
    tabIndex: L.tabIndex,
    onFocus: (C) => {
      L.activate(), f?.(C);
    },
    "data-dropdown-item": "",
    "data-dropdown-page": g,
    onClick: (C) => {
      if (v?.(C), !C.defaultPrevented) {
        if (u(g)) {
          const I = C.currentTarget.closest("[data-dropdown-content]");
          if (!u(I)) return;
          const $ = be(I).indexOf(C.currentTarget);
          N({
            id: g,
            trigger: {
              id: S,
              index: $,
              page: g,
              label: We(C.currentTarget)
            }
          });
          return;
        }
        _ && T();
      }
    },
    render: (C) => /* @__PURE__ */ r(pe, {
      ...C,
      render: d ?? /* @__PURE__ */ r("button", { type: "button" }),
      disabled: l,
      color: e,
      startIcon: t,
      endIcon: n,
      description: a,
      descriptionPlacement: o,
      hotkeys: i,
      hasSubmenu: s ?? u(g),
      children: c
    })
  });
}, so = "_content_265yk_1", co = "_page_265yk_12", lo = "_section_265yk_16", uo = "_separator_265yk_24", mo = "_back_265yk_32", _o = "_searchContainer_265yk_47", vo = "_search_265yk_47", po = "_status_265yk_64", ho = "_header_265yk_70", fo = "_title_265yk_86", q = {
  content: so,
  page: co,
  section: lo,
  separator: uo,
  back: mo,
  searchContainer: _o,
  search: vo,
  status: po,
  header: ho,
  title: fo
}, go = ({ children: e = "Back", className: t, onClick: n, ...a }) => {
  const { goBack: o, canGoBack: i } = O();
  return /* @__PURE__ */ r(It, {
    ...a,
    className: p(q.back, t),
    "data-dropdown-back": "",
    disabled: a.disabled || !i,
    startIcon: /* @__PURE__ */ r(Rt, {}),
    closeOnClick: !1,
    onClick: (s) => {
      n?.(s), !s.defaultPrevented && o();
    },
    children: e
  });
}, bo = ({ render: e, children: t, "aria-label": n, ...a }) => /* @__PURE__ */ r(_t.Close, {
  ...a,
  "aria-label": n,
  render: e ?? /* @__PURE__ */ r(Oa, {
    size: "sm",
    "aria-label": n,
    children: t ?? /* @__PURE__ */ r(qe, {})
  }),
  children: u(e) ? t : void 0
}), He = ({ content: e, target: t, edge: n = "first", type: a }) => {
  const o = u(t?.id) ? e.ownerDocument.getElementById(t.id) : null;
  if (u(o) && e.contains(o)) return o;
  const i = be(e), s = u(t) ? i.filter((f) => f.dataset.dropdownPage === t.page) : [], [c] = s;
  if (s.length === 1 && u(c)) return c;
  const d = W(t?.label) ? s.filter((f) => We(f) === t?.label) : [], [l] = d;
  if (d.length === 1 && u(l)) return l;
  const m = u(t) ? i[t.index] : void 0;
  if (u(m)) return m;
  const _ = e.querySelector('input:not(:disabled):not([type="hidden"]),button:not(:disabled),textarea:not(:disabled),select:not(:disabled),a[href],[tabindex="0"]');
  if ((Array.from(e.querySelectorAll("[data-dropdown-page-type]")).find((f) => f.closest("[data-dropdown-content]") === e)?.dataset.dropdownPageType ?? a ?? e.dataset.type) === "panel") return _ ?? e;
  const v = e.querySelector("[data-dropdown-search]:not(:disabled)");
  return u(v) ? v : (n === "last" ? i[i.length - 1] : i[0]) ?? _ ?? e;
}, Co = ({ contentRef: e }) => {
  const { open: t, pageId: n, pageFocusRequest: a, setPageFocusRequest: o } = O();
  return fe(() => {
    u(a) && (o(void 0), !(!t || a.pageId !== n || !u(e.current)) && He({
      content: e.current,
      target: a.target
    }).focus());
  }, [
    e,
    t,
    n,
    a,
    o
  ]), null;
}, yt = (e) => {
  if (e.dataset.type === "panel") return;
  const t = e.querySelector("[data-dropdown-search]:not(:disabled)");
  if (!(!u(t) || !W(t.value.trim())))
    return be(e).find((n) => n.hasAttribute("data-dropdown-option-item"));
}, Io = ({ content: e }) => {
  const { setSearchTargetId: t } = O();
  return fe(() => {
    if (!u(e)) return;
    const n = () => t(yt(e)?.id);
    n();
    const a = new MutationObserver(n);
    return a.observe(e, {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["disabled", "aria-disabled"]
    }), e.addEventListener("input", n), () => {
      a.disconnect(), e.removeEventListener("input", n), t(void 0);
    };
  }, [e, t]), null;
}, yo = (e) => (e.ctrlKey || e.metaKey) && !e.defaultPrevented, No = (e) => Array.from(e.ownerDocument.querySelectorAll("[data-dropdown-item][aria-controls]")).find((t) => t.getAttribute("aria-controls") === e.id), wo = ({ key: e, items: t, currentIndex: n, search: a, isSearch: o }) => {
  const i = t.length - 1;
  if (e === "ArrowDown") return t[n === i ? 0 : n + 1];
  if (e === "ArrowUp" && n === 0 && u(a)) return a;
  if (e === "ArrowUp") return t[n <= 0 ? i : n - 1];
  if (!o && e === "Home") return t[0];
  if (!o && e === "End") return t[i];
}, ko = 500, So = ({ type: e, isSubmenu: t, setOpen: n }) => {
  const [a, o] = D({
    text: "",
    timestamp: 0
  });
  return (i) => {
    if (i.defaultPrevented) return;
    const s = i.currentTarget, c = i.target;
    if (!(c instanceof HTMLElement) || c.closest("[data-dropdown-content]") !== s) return;
    const d = c.matches('input,textarea,select,[contenteditable="true"]'), l = getComputedStyle(s).direction === "rtl" ? "ArrowRight" : "ArrowLeft";
    if (t && (i.key === "Escape" || !d && i.key === l)) {
      i.preventDefault(), i.stopPropagation(), No(s)?.focus(), n(!1);
      return;
    }
    if (e === "panel") return;
    const m = s.querySelector("[data-dropdown-search]:not(:disabled)"), _ = c === m;
    if (d && !_) return;
    const v = be(s).filter((k) => !u(m) || !k.hasAttribute("data-dropdown-back")), f = _ && i.key === "Enter" && !i.nativeEvent.isComposing ? yt(s) : void 0;
    if (u(f)) {
      i.preventDefault(), f.click();
      return;
    }
    const g = v.indexOf(c), S = wo({
      key: i.key,
      items: v,
      currentIndex: g,
      search: m,
      isSearch: _
    });
    if (u(S)) {
      i.preventDefault(), S.focus();
      return;
    }
    if (d || i.key.length !== 1 || i.key === " " || i.altKey || i.ctrlKey || i.metaKey) return;
    const y = Date.now(), b = y - a.timestamp > ko ? i.key : a.text + i.key;
    o({
      text: b,
      timestamp: y
    });
    const T = ([...b].every((k) => k === b[0]) ? i.key : b).toLocaleLowerCase(), N = [...v.slice(g + 1), ...v.slice(0, g + 1)].find((k) => We(k).trim().toLocaleLowerCase().startsWith(T));
    u(N) && (i.preventDefault(), N.focus());
  };
}, To = ({ side: e, align: t = "start", sideOffset: n = 0, alignOffset: a, anchor: o, container: i, keepMounted: s, width: c = 200, className: d, style: l, children: m, initialFocus: _, onKeyDown: v, onClick: f, onMouseDown: g, onPointerDown: S, ref: y, ...b }) => {
  const { type: T, isSubmenu: N, setOpen: k, initialFocusEdge: A, focusOnOpen: L } = O(), C = je(null), [I, $] = D(null), B = kr(C, y, $), H = So({
    type: T,
    isSubmenu: N,
    setOpen: k
  });
  return /* @__PURE__ */ h(z, { children: [
    /* @__PURE__ */ r(he.Popup, {
      ...b,
      ref: B,
      side: e ?? (N ? "inline-end" : "bottom"),
      align: t,
      sideOffset: n,
      alignOffset: a,
      anchor: o,
      container: i,
      keepMounted: s,
      role: T === "menu" ? "menu" : "dialog",
      "data-dropdown-content": "",
      "data-type": T,
      className: G(q.content, d),
      style: (w) => ({
        width: c,
        ...vr(l) ? l(w) : l
      }),
      initialFocus: _ ?? (() => L ? u(C.current) ? He({
        content: C.current,
        edge: A,
        type: T
      }) : !0 : !1),
      onKeyDown: (w) => {
        v?.(w), H(w), yo(w) || w.stopPropagation();
      },
      onClick: (w) => {
        w.stopPropagation(), f?.(w);
      },
      onMouseDown: (w) => {
        w.stopPropagation(), g?.(w);
      },
      onPointerDown: (w) => {
        w.stopPropagation(), S?.(w);
      },
      children: m
    }),
    /* @__PURE__ */ r(Co, { contentRef: C }),
    /* @__PURE__ */ r(Io, { content: I })
  ] });
}, xo = ({ className: e, ...t }) => /* @__PURE__ */ r(dt, {
  ...t,
  role: "status",
  "aria-live": "polite",
  className: p(q.status, e)
}), Ao = ({ render: e, ref: t, className: n, ...a }) => de({
  render: e,
  ref: t,
  props: {
    ...a,
    className: p(q.header, n)
  }
}), Lo = ({ className: e, ...t }) => /* @__PURE__ */ r(dt, {
  ...t,
  role: "status",
  "aria-live": "polite",
  "aria-busy": "true",
  className: p(q.status, e)
}), Do = ({ selected: e, indicator: t, onSelect: n, closeOnSelect: a, color: o, startIcon: i, endIcon: s, description: c, descriptionPlacement: d, hotkeys: l, hasSubmenu: m, children: _, render: v, disabled: f = !1, nativeButton: g = !u(v), onClick: S, onFocus: y, id: b, ...T }) => {
  const { type: N, multiple: k, closeTree: A, searchTargetId: L } = O(), C = N === "menu", I = k ? "menuitemcheckbox" : "menuitemradio", $ = re(), B = b ?? $, H = Ke({ id: B });
  return /* @__PURE__ */ r(mt, {
    ...T,
    id: B,
    disabled: f,
    nativeButton: g,
    role: C ? I : void 0,
    "aria-checked": C ? e : void 0,
    "aria-pressed": C ? void 0 : e,
    tabIndex: H.tabIndex,
    onFocus: (w) => {
      H.activate(), y?.(w);
    },
    "data-dropdown-item": "",
    "data-dropdown-option-item": "",
    onClick: (w) => {
      S?.(w), !w.defaultPrevented && (n?.(), (a ?? !k) && A());
    },
    render: (w) => /* @__PURE__ */ r(pe, {
      ...w,
      render: v ?? /* @__PURE__ */ r("button", { type: "button" }),
      disabled: f,
      selected: e,
      focused: L === B,
      indicator: t ?? (k ? "checkbox" : "check"),
      color: o,
      startIcon: i,
      endIcon: s,
      description: c,
      descriptionPlacement: d,
      hotkeys: l,
      hasSubmenu: m,
      children: _
    })
  });
}, Bo = ({ id: e, type: t, children: n }) => {
  const a = O(), { registerPage: o } = a, i = Ee((s) => {
    u(s) && o({
      id: e,
      type: t
    });
  }, [
    e,
    t,
    o
  ]);
  return a.pageId !== e ? null : /* @__PURE__ */ r(_e.Provider, {
    value: {
      ...a,
      type: t ?? a.rootType
    },
    children: /* @__PURE__ */ r("div", {
      ref: i,
      className: q.page,
      "data-dropdown-page-type": t ?? a.rootType,
      children: n
    })
  });
}, Mo = ({ open: e, registerOpenNestedRoot: t }) => (gr(() => {
  if (e)
    return t?.();
}, [e, t]), null), Eo = [
  "mousedown",
  "touchend",
  "focusout"
], at = (e) => {
  e.preventDefault(), e.stopPropagation();
}, Po = (e) => {
  if (e.type === "click") {
    at(e);
    return;
  }
  if (!Eo.includes(e.type)) return;
  const t = e.target instanceof Node ? e.target.ownerDocument ?? document : document, n = new AbortController(), a = () => n.abort(), o = {
    capture: !0,
    signal: n.signal
  };
  t.addEventListener("click", (i) => {
    at(i), a();
  }, o), t.addEventListener("pointerdown", a, o), t.addEventListener("keydown", a, o);
}, Nt = ({ children: e, type: t, open: n, defaultOpen: a = !1, onOpenChange: o, multiple: i = !1, defaultPage: s = "root", isSubmenu: c = !1 }) => {
  const d = le(_e), l = je(0), m = Ee(() => (l.current += 1, () => {
    l.current -= 1;
  }), []), [_, v] = D(a), f = n ?? _, [g, S] = D(f), [y, b] = D([{ id: s }]), [T, N] = D(), [k, A] = D(), L = y[y.length - 1]?.id, [C, I] = D(), [$, B] = D("first"), [H, w] = D(!0), [kt, Ue] = D();
  g !== f && (S(f), f || (b([{ id: s }]), N(void 0), I(void 0), B("first"), w(!0), Ue(void 0)));
  const Ce = (E) => {
    u(n) || v(E), o?.(E);
  }, St = () => {
    Ce(!1), c && d?.closeTree();
  }, Tt = ({ id: E, trigger: R }) => {
    I({ pageId: E }), b((J) => [...J, {
      id: E,
      trigger: R
    }]);
  }, xt = () => {
    const E = y.at(-2);
    if (!u(E)) return;
    const R = y.at(-1)?.trigger;
    I({
      pageId: E.id,
      target: R
    }), b((J) => J.slice(0, -1));
  }, At = Ee(({ id: E, type: R }) => {
    if (!f) return;
    const J = R ?? t;
    N((Ie) => Ie?.id === E && Ie.type === J ? Ie : {
      id: E,
      type: J
    });
  }, [f, t]);
  return /* @__PURE__ */ r(he.Root, {
    open: f,
    onOpenChange: (E, R) => {
      const J = R.reason === "outside-press" || R.reason === "focus-out";
      if (J && l.current > 0) {
        R.cancel();
        return;
      }
      J && Po(R.event), w(R.reason !== "trigger-hover"), Ce(E);
    },
    children: /* @__PURE__ */ h(_e.Provider, {
      value: {
        type: u(T) && T.id === L ? T.type : t,
        rootType: t,
        open: f,
        multiple: i,
        isSubmenu: c,
        parentType: d?.type,
        activeItemId: k,
        parentActiveItemId: d?.activeItemId,
        setActiveItemId: A,
        setParentActiveItemId: d?.setActiveItemId,
        pageId: L,
        pageFocusRequest: C,
        setPageFocusRequest: I,
        canGoBack: y.length > 1,
        initialFocusEdge: $,
        setInitialFocusEdge: B,
        focusOnOpen: H,
        setFocusOnOpen: w,
        setOpen: Ce,
        closeTree: St,
        goToPage: Tt,
        goBack: xt,
        registerPage: At,
        registerOpenNestedRoot: m,
        searchTargetId: kt,
        setSearchTargetId: Ue
      },
      children: [/* @__PURE__ */ r(Mo, {
        open: f,
        registerOpenNestedRoot: c ? void 0 : d?.registerOpenNestedRoot
      }), e]
    })
  });
}, Ro = ({ onValueChange: e, className: t, ...n }) => {
  const { searchTargetId: a } = O();
  return /* @__PURE__ */ r("div", {
    className: q.searchContainer,
    children: /* @__PURE__ */ r(Zt, {
      type: "search",
      autoComplete: "off",
      "aria-activedescendant": a,
      ...n,
      "data-dropdown-search": "",
      className: G(q.search, t),
      onValueChange: (o) => e?.(o)
    })
  });
}, qo = ({ label: e, scrollable: t, className: n, children: a, ...o }) => /* @__PURE__ */ h(sr, {
  ...o,
  "data-scrollable": t || void 0,
  className: p(q.section, n),
  children: [u(e) && /* @__PURE__ */ r(ir, { children: e }), a]
}), zo = ({ className: e, ...t }) => /* @__PURE__ */ r(cr, {
  ...t,
  role: "separator",
  "data-dropdown-separator": "",
  className: p(q.separator, e)
}), Oo = ({ type: e = "menu", ...t }) => /* @__PURE__ */ r(Nt, {
  ...t,
  type: e,
  isSubmenu: !0
}), $o = ({ color: e, startIcon: t, endIcon: n, description: a, descriptionPlacement: o, hotkeys: i, hasSubmenu: s = !0, children: c, render: d, disabled: l = !1, nativeButton: m = !u(d), openOnHover: _ = !0, onKeyDown: v, onFocus: f, id: g, ...S }) => {
  const { type: y, parentType: b, open: T, setOpen: N, setFocusOnOpen: k } = O(), A = re(), L = g ?? A, C = Ke({
    id: L,
    isSubmenuTrigger: !0
  });
  return /* @__PURE__ */ r(he.Trigger, {
    ...S,
    id: L,
    disabled: l,
    nativeButton: m,
    openOnHover: _,
    role: b === "menu" ? "menuitem" : void 0,
    "aria-haspopup": y === "menu" ? "menu" : "dialog",
    tabIndex: C.tabIndex,
    onFocus: (I) => {
      C.activate(), f?.(I);
    },
    "data-dropdown-item": "",
    onKeyDown: (I) => {
      if (v?.(I), I.defaultPrevented || l) return;
      const $ = getComputedStyle(I.currentTarget).direction === "rtl" ? "ArrowLeft" : "ArrowRight";
      if (I.key === $) {
        I.preventDefault(), I.stopPropagation(), k(!0);
        const B = I.currentTarget.getAttribute("aria-controls"), H = u(B) ? I.currentTarget.ownerDocument.getElementById(B) : null;
        if (T && u(H)) {
          He({
            content: H,
            type: y
          }).focus();
          return;
        }
        N(!0);
      }
    },
    render: (I) => /* @__PURE__ */ r(pe, {
      ...I,
      render: d ?? /* @__PURE__ */ r("button", { type: "button" }),
      disabled: l,
      color: e,
      startIcon: t,
      endIcon: n,
      description: a,
      descriptionPlacement: o,
      hotkeys: i,
      hasSubmenu: s,
      children: c
    })
  });
}, jo = ({ className: e, render: t, ...n }) => /* @__PURE__ */ r(_t.Title, {
  ...n,
  render: t ?? /* @__PURE__ */ r("div", {}),
  className: G(q.title, e)
}), Fo = ({ onKeyDown: e, onClick: t, ...n }) => {
  const { type: a, setOpen: o, setInitialFocusEdge: i, setFocusOnOpen: s } = O();
  return /* @__PURE__ */ r(he.Trigger, {
    ...n,
    "aria-haspopup": a === "menu" ? "menu" : "dialog",
    onClick: (c) => {
      c.stopPropagation(), c.preventDefault(), t?.(c);
    },
    onKeyDown: (c) => {
      e?.(c), !(c.defaultPrevented || n.disabled || a === "panel") && (c.key !== "ArrowDown" && c.key !== "ArrowUp" || (c.preventDefault(), s(!0), i(c.key === "ArrowUp" ? "last" : "first"), o(!0)));
    }
  });
}, Wo = Nt, Ts = {
  Root: Wo,
  Trigger: Fo,
  Content: To,
  ActionItem: It,
  OptionItem: Do,
  Search: Ro,
  Header: Ao,
  Title: jo,
  Close: bo,
  Page: Bo,
  Back: go,
  Submenu: Oo,
  SubmenuTrigger: $o,
  Section: qo,
  Separator: zo,
  Loading: Lo,
  Empty: xo
}, xs = {
  gray: "Gray",
  tomato: "Tomato",
  red: "Red",
  ruby: "Ruby",
  crimson: "Crimson",
  pink: "Pink",
  plum: "Plum",
  purple: "Purple",
  violet: "Violet",
  iris: "Iris",
  cyan: "Cyan",
  turquoise: "Turquoise",
  sky: "Sky",
  blue: "Blue",
  jade: "Jade",
  green: "Green",
  grass: "Grass",
  mint: "Mint",
  lime: "Lime",
  bronze: "Bronze",
  gold: "Gold",
  brown: "Brown",
  orange: "Orange",
  amber: "Amber",
  yellow: "Yellow"
}, Ko = "_iconContainer_1ivx0_1", Ho = "_withBackground_1ivx0_9", ot = {
  iconContainer: Ko,
  withBackground: Ho
}, Je = ({ children: e, className: t, hasBackground: n = !0 }) => /* @__PURE__ */ r("div", {
  className: p(ot.iconContainer, n && ot.withBackground, t),
  children: e
}), Jo = ({ Icon: e, iconThemeColor: t, withContainer: n = !1, withContainerBackground: a = !0 }) => {
  const o = M();
  if (!e) return null;
  if (u(t)) return /* @__PURE__ */ r(ft, {
    Icon: e,
    color: t,
    size: o.icon.size.md,
    stroke: o.icon.stroke.sm
  });
  const i = /* @__PURE__ */ r(e, {
    size: o.icon.size.md,
    stroke: o.icon.stroke.sm
  });
  return n ? /* @__PURE__ */ r(Je, {
    hasBackground: a,
    children: i
  }) : i;
}, Vo = "_iconSwapContainer_g9ywp_1", Go = "_defaultIcon_g9ywp_8", Uo = "_hoverIcon_g9ywp_13", De = {
  iconSwapContainer: Vo,
  defaultIcon: Go,
  hoverIcon: Uo
}, Yo = ({ LeftIcon: e, iconThemeColor: t, withIconContainer: n = !1, gripIconColor: a }) => {
  const o = M();
  if (!e) return null;
  const i = /* @__PURE__ */ h("div", {
    className: De.iconSwapContainer,
    children: [/* @__PURE__ */ r("div", {
      className: p(De.defaultIcon, "grip-swap-default-icon"),
      children: u(t) ? /* @__PURE__ */ r(ft, {
        Icon: e,
        color: t,
        size: o.icon.size.md,
        stroke: o.icon.stroke.sm
      }) : /* @__PURE__ */ r(e, {
        size: o.icon.size.md,
        stroke: o.icon.stroke.sm
      })
    }), /* @__PURE__ */ r("div", {
      className: p(De.hoverIcon, "grip-swap-hover-icon"),
      children: /* @__PURE__ */ r(Me, {
        size: o.icon.size.md,
        stroke: o.icon.stroke.sm,
        color: a
      })
    })]
  });
  return n && !u(t) ? /* @__PURE__ */ r(Je, { children: i }) : i;
}, Xo = "_menuItemBase_1jkew_1", Qo = "_hoverableMenuItemBase_1jkew_54", Zo = "_menuItemLabel_1jkew_136", ei = "_menuItemLabelLight_1jkew_145", ti = "_noIconFiller_1jkew_155", ri = "_menuItemLeftContent_1jkew_159", ni = "_menuItemRightContent_1jkew_172", ai = "_draggableItem_1jkew_183", oi = "_menuItemIconCheckContainer_1jkew_189", ii = "_menuItemContextualText_1jkew_196", si = "_rightMenuItemContextualText_1jkew_206", K = {
  menuItemBase: Xo,
  hoverableMenuItemBase: Qo,
  menuItemLabel: Zo,
  menuItemLabelLight: ei,
  noIconFiller: ti,
  menuItemLeftContent: ri,
  menuItemRightContent: ni,
  draggableItem: ai,
  menuItemIconCheckContainer: oi,
  menuItemContextualText: ii,
  rightMenuItemContextualText: si
}, ci = $e(({ accent: e, isKeySelected: t, isHoverBackgroundDisabled: n, hovered: a, disabled: o, focused: i, className: s, children: c, ...d }, l) => /* @__PURE__ */ r("div", {
  ref: l,
  className: p(K.menuItemBase, s),
  "data-accent": e,
  "data-key-selected": t || void 0,
  "data-hover-background-disabled": n || void 0,
  "data-disabled": o || void 0,
  "data-focused": i || void 0,
  ...d,
  children: c
}));
ci.displayName = "StyledMenuItemBase";
var X = (e, t) => {
  const n = $e(({ className: a, children: o, ...i }, s) => /* @__PURE__ */ r("div", {
    ref: s,
    className: p(e, a),
    ...i,
    children: o
  }));
  return n.displayName = t, n;
}, li = X(K.menuItemLabel, "StyledMenuItemLabel"), As = X(K.menuItemLabelLight, "StyledMenuItemLabelLight"), Ls = X(K.noIconFiller, "StyledNoIconFiller"), wt = X(K.menuItemLeftContent, "StyledMenuItemLeftContent"), Re = X(K.menuItemRightContent, "StyledMenuItemRightContent"), it = X(K.draggableItem, "StyledDraggableItem"), Ve = $e(({ accent: e, isKeySelected: t, isHoverBackgroundDisabled: n, hovered: a, disabled: o, focused: i, isIconDisplayedOnHoverOnly: s, cursor: c, className: d, children: l, ...m }, _) => /* @__PURE__ */ r("div", {
  ref: _,
  className: p(K.hoverableMenuItemBase, d),
  "data-accent": e,
  "data-key-selected": t || void 0,
  "data-hover-background-disabled": n || void 0,
  "data-disabled": o || void 0,
  "data-focused": i || void 0,
  "data-icon-displayed-on-hover-only": s || void 0,
  "data-cursor": c,
  ...m,
  children: l
}));
Ve.displayName = "StyledHoverableMenuItemBase";
var di = X(K.menuItemContextualText, "StyledMenuItemContextualText"), ui = X(K.rightMenuItemContextualText, "StyledRightMenuItemContextualText"), mi = "_mainText_d0zu3_1", _i = "_menuItemLabelRight_d0zu3_9", st = {
  mainText: mi,
  menuItemLabelRight: _i
}, Ge = ({ className: e, LeftComponent: t, LeftIcon: n, iconThemeColor: a, withIconContainer: o = !1, withIconContainerBackground: i = !0, text: s, contextualText: c, contextualTextPosition: d = "left", gripMode: l = "never", disabled: m = !1 }) => {
  const _ = M(), v = o ? V.font.color.tertiary : m ? V.font.color.extraLight : V.font.color.light;
  return /* @__PURE__ */ h(wt, {
    className: e,
    children: [
      l === "always" && (o ? /* @__PURE__ */ r(Je, {
        hasBackground: i,
        children: /* @__PURE__ */ r(it, { children: /* @__PURE__ */ r(Me, {
          size: _.icon.size.md,
          stroke: _.icon.stroke.sm,
          color: v
        }) })
      }) : /* @__PURE__ */ r(it, { children: /* @__PURE__ */ r(Me, {
        size: _.icon.size.md,
        stroke: _.icon.stroke.sm,
        color: v
      }) })),
      l === "onHover" ? /* @__PURE__ */ r(Yo, {
        LeftIcon: n,
        iconThemeColor: a,
        withIconContainer: o,
        gripIconColor: v
      }) : /* @__PURE__ */ r(Jo, {
        Icon: n,
        iconThemeColor: a,
        withContainer: o,
        withContainerBackground: i
      }),
      t,
      /* @__PURE__ */ h(li, { children: [te(s) ? /* @__PURE__ */ r("div", {
        className: st.mainText,
        children: /* @__PURE__ */ r(se, { text: s })
      }) : s, d === "left" && /* @__PURE__ */ r(z, { children: te(c) ? W(c) && /* @__PURE__ */ r(di, { children: /* @__PURE__ */ r(se, {
        text: `· ${c}`,
        tooltipContent: c
      }) }) : c })] }),
      d === "right" && /* @__PURE__ */ r("div", {
        className: st.menuItemLabelRight,
        children: /* @__PURE__ */ r(ui, { children: te(c) ? /* @__PURE__ */ r(se, { text: c }) : c })
      })
    ]
  });
}, vi = "_subMenuIcon_j232v_1", pi = "_subMenuIconOpened_j232v_9", ct = {
  subMenuIcon: vi,
  subMenuIconOpened: pi
}, hi = ({ accent: e = "default", className: t, withIconContainer: n = !1, withIconContainerBackground: a = !0, iconButtons: o, isIconDisplayedOnHoverOnly: i = !0, LeftIcon: s, iconThemeColor: c, LeftComponent: d, RightIcon: l, RightComponent: m, onClick: _, onMouseEnter: v, onMouseLeave: f, testId: g, text: S, contextualTextPosition: y = "left", contextualText: b, hasSubMenu: T = !1, disabled: N = !1, focused: k = !1, selected: A = !1, hotKeys: L, isSubMenuOpened: C = !1 }) => {
  const I = M();
  return /* @__PURE__ */ h(Ve, {
    "data-testid": g ?? void 0,
    onClick: N ? void 0 : (B) => {
      _ && (B.preventDefault(), B.stopPropagation(), _?.(B));
    },
    disabled: N,
    className: t,
    accent: e,
    isIconDisplayedOnHoverOnly: i,
    onMouseEnter: v,
    onMouseLeave: f,
    focused: k || A,
    children: [/* @__PURE__ */ r(Ge, {
      LeftIcon: s ?? void 0,
      iconThemeColor: c,
      LeftComponent: d,
      withIconContainer: n,
      withIconContainerBackground: a,
      text: S,
      contextualText: b,
      contextualTextPosition: y,
      disabled: N
    }), /* @__PURE__ */ h(Re, { children: [
      o && /* @__PURE__ */ r(Re, {
        className: "hoverable-buttons",
        children: o
      }),
      L && /* @__PURE__ */ r(ar, { hotKeys: L }),
      l && /* @__PURE__ */ r(l, {
        size: I.icon.size.md,
        stroke: I.icon.stroke.sm
      }),
      m,
      T && /* @__PURE__ */ r("div", {
        className: p(ct.subMenuIcon, C && ct.subMenuIconOpened),
        style: { visibility: N ? "hidden" : "visible" },
        children: /* @__PURE__ */ r(Mt, {
          size: I.icon.size.sm,
          color: I.font.color.light
        })
      })
    ] })]
  });
}, Ds = ({ accent: e = "default", className: t, iconButtons: n, isIconDisplayedOnHoverOnly: a = !0, isTooltipOpen: o, onClick: i, onMouseEnter: s, onMouseLeave: c, testId: d, avatar: l, hasSubMenu: m = !1, text: _, contextualText: v }) => /* @__PURE__ */ r(hi, {
  accent: e,
  className: t,
  iconButtons: n,
  isIconDisplayedOnHoverOnly: a,
  isTooltipOpen: o,
  LeftComponent: u(l) ? /* @__PURE__ */ r(lr, {
    name: l.name,
    src: l.src,
    colorSeed: l.colorSeed,
    size: l.size,
    shape: l.shape
  }) : void 0,
  onClick: i,
  onMouseEnter: s,
  onMouseLeave: c,
  testId: d,
  text: _,
  contextualText: v,
  hasSubMenu: m
}), Bs = ({ LeftIcon: e, withIconContainer: t = !1, accent: n = "default", iconButtons: a, onClick: o, text: i, contextualText: s, isDragDisabled: c = !1, className: d, isIconDisplayedOnHoverOnly: l = !0, gripMode: m = "never" }) => /* @__PURE__ */ h(Ve, {
  onClick: o,
  accent: n,
  className: d,
  isIconDisplayedOnHoverOnly: l,
  cursor: m !== "never" ? c ? "default" : "drag" : "default",
  children: [/* @__PURE__ */ r(Ge, {
    LeftIcon: e,
    text: i,
    contextualText: s,
    withIconContainer: t,
    disabled: c,
    gripMode: m
  }), a && /* @__PURE__ */ r(Re, {
    className: "hoverable-buttons",
    children: a
  })]
}), fi = "_suggestionMenuItem_1qyjt_1", gi = { suggestionMenuItem: fi }, Ms = ({ LeftIcon: e, withIconContainer: t = !1, text: n, contextualText: a = void 0, contextualTextPosition: o = "left", className: i, selected: s, onClick: c }) => {
  const d = (l) => {
    c && (l.preventDefault(), l.stopPropagation(), c?.(l));
  };
  return /* @__PURE__ */ r("li", {
    className: p(gi.suggestionMenuItem, i),
    "data-selected": s || void 0,
    role: u(c) ? "button" : void 0,
    tabIndex: u(c) ? 0 : void 0,
    onClick: d,
    onKeyDown: ve,
    children: /* @__PURE__ */ r(wt, { children: /* @__PURE__ */ r(Ge, {
      LeftIcon: e ?? void 0,
      text: n,
      contextualText: a,
      contextualTextPosition: o,
      withIconContainer: t
    }) })
  });
}, bi = "_menuPicker_o8ra4_1", Ci = "_iconContainer_o8ra4_41", Ii = "_label_o8ra4_50", Be = {
  menuPicker: bi,
  iconContainer: Ci,
  label: Ii
}, Es = ({ id: e, icon: t, label: n, selected: a = !1, disabled: o = !1, showLabel: i = !0, onClick: s, className: c, testId: d, tooltipContent: l, tooltipDelay: m = 0, tooltipOffset: _ = 5 }) => {
  const v = M();
  return /* @__PURE__ */ r(ut, {
    content: l,
    disabled: !W(l),
    sideOffset: _,
    side: "bottom",
    positionMethod: "fixed",
    delay: m,
    children: /* @__PURE__ */ h("button", {
      id: e,
      disabled: o,
      onClick: s,
      className: p(Be.menuPicker, c),
      "data-testid": d,
      "data-selected": a ? "" : void 0,
      "aria-pressed": a,
      "aria-disabled": o,
      "aria-label": n,
      children: [/* @__PURE__ */ r("div", {
        className: Be.iconContainer,
        children: /* @__PURE__ */ r(t, {
          size: v.icon.size.md,
          stroke: v.icon.stroke.sm
        })
      }), u(n) && i && /* @__PURE__ */ r("div", {
        className: Be.label,
        "data-selected": a ? "" : void 0,
        "data-disabled": o ? "" : void 0,
        children: n
      })]
    })
  });
}, yi = "_iconButton_19i33_1", Ni = { iconButton: yi }, wi = ({ Icon: e, isActive: t, onClick: n, ariaLabel: a }) => {
  const o = M();
  return /* @__PURE__ */ r("button", {
    type: "button",
    className: Ni.iconButton,
    "data-active": t ? "" : void 0,
    "aria-label": a,
    "aria-pressed": t,
    onClick: n,
    children: /* @__PURE__ */ r(e, {
      color: V.grayScale.gray10,
      size: o.icon.size.lg,
      "aria-hidden": !0
    })
  });
}, ki = "_container_vsk1i_1", Si = { container: ki }, Ps = ({ activeItemName: e, isHidden: t = !1, items: n }) => /* @__PURE__ */ r("nav", {
  className: Si.container,
  "data-hidden": t ? "" : void 0,
  "aria-hidden": t,
  children: n.map(({ Icon: a, name: o, label: i, onClick: s }) => /* @__PURE__ */ r(wi, {
    Icon: a,
    isActive: e === o,
    onClick: s,
    ariaLabel: i
  }, o))
}), Ti = "_root_os1x1_1", xi = { root: Ti }, Rs = ({ label: e, href: t, onClick: n, className: a }) => {
  if (!W(e)) return /* @__PURE__ */ r(z, {});
  const o = (i) => {
    i.stopPropagation(), n?.(i);
  };
  return /* @__PURE__ */ r("a", {
    href: Ut(t),
    target: "_blank",
    rel: "noreferrer",
    onClick: o,
    className: p(xi.root, a),
    children: e
  });
}, Ai = "_button_1fa8x_1", Li = { button: Ai }, qs = ({ active: e = !1, className: t, children: n, startIcon: a, endIcon: o, badge: i, size: s = "sm", ...c }) => /* @__PURE__ */ r(P, {
  ...c,
  variant: "ghost",
  size: s,
  "data-active": e || void 0,
  className: G(p(dr.tab, Li.button), t),
  children: /* @__PURE__ */ r(ur, {
    startIcon: a,
    endIcon: o,
    badge: i,
    children: n
  })
});
export {
  ue as A,
  us as B,
  fs as C,
  hs as D,
  Xn as E,
  vs as F,
  ls as H,
  _s as I,
  ms as L,
  ge as M,
  gt as N,
  Yn as O,
  ps as P,
  ft as R,
  et as S,
  Qn as T,
  cs as U,
  ds as V,
  Is as _,
  Ms as a,
  bs as b,
  hi as c,
  Ss as d,
  ks as f,
  Oa as g,
  ys as h,
  Es as i,
  bt as j,
  Ct as k,
  xs as l,
  Ns as m,
  Rs as n,
  Bs as o,
  ws as p,
  Ps as r,
  Ds as s,
  qs as t,
  Ts as u,
  Ea as v,
  da as w,
  gs as x,
  Cs as y,
  fn as z
};
